<template lang="pug">
.v-modal-cookie.modal-cookie.modal.modal--cookie(v-if="cookieData" :class="{'open': isOpen, 'close': !isOpen}" @click.stop)
	.modal-cookie__surface
		.modal__container
			.modal__content-slot.modal-cookie__content-slot
				.modal-window(role="dialog")
					button.modal-window__close(type="button" aria-label="Закрыть" @click="closeModal")
						v-svg-icon.modal-window__close-icon(icon="close")
					.modal-window__body
						.modal-cookie__main
							.modal-cookie__title(v-if="cookieData.title") {{ cookieData.title }}
							.modal-cookie__text.flc(v-if="cookieData.text" v-html="cookieData.text")
							.modal-cookie__action.flc(v-if="cookieData.action")
								.modal-cookie__action-item.flc(v-if="cookieData.action.apply")
									button.modal-cookie__action-btn.btn.btn--primary-dark(type="button" @click="allowAllCookie") {{ cookieData.action.apply }}
								.modal-cookie__action-item.flc(v-if="cookieData.action.decline")
									button.modal-cookie__action-btn.btn.btn--transparent(type="button" @click="disallowAllCookie") {{ cookieData.action.decline }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue'

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			cookieData: null,
			isOpen: true,
			togglerLocalValue: true
		};
	},

	methods: {
		getCookie(name) {
			let matches = document.cookie.match(new RegExp(
				'(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
			));
			return matches ? decodeURIComponent(matches[1]) : undefined;
		},

		setCookie(name, value, options = {}) {
			options = {
				// при необходимости добавьте другие значения по умолчанию
				...options
			};
			if (options.expires instanceof Date) {
				options.expires = options.expires.toUTCString();
			}
			let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
			for (let optionKey in options) {
				updatedCookie += '; ' + optionKey;
				let optionValue = options[optionKey];
				if (optionValue !== true) {
					updatedCookie += '=' + optionValue;
				}
			}
			document.cookie = updatedCookie;
		},

		deleteCookie(name) {
			this.setCookie(name, '', {
				'max-age': -1
			});
		},

		closeModal() {
			this.isOpen = false;
		},

		allowAllCookie() {
			this.setCookie(this.cookieData.cookie_name, this.cookieData.messageID, {secure: true, 'max-age': 60 * 60 * 24 * 365, path: this.cookieData.cookie_options_path});
			this.closeModal();
		},

		disallowAllCookie() {
			this.closeModal();
		},

		dataSet(data) {
			this.cookieData = data;
			this.isOpen = !this.getCookie(this.cookieData.cookie_name)
		}
	}
};
</script>